export const BuildInfo = {timestamp:1792187222000}
